import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { SecondaryLink } from 'components/core';

const Wrapper = styled.div`
  margin-top: 1rem;
  display: grid;
  grid-template-columns: 2fr 3fr;
  grid-column-gap: 10px;
  align-items: center;
  img {
    margin: 0;
  }
  span {
    display: block;
  }
  .category {
    color: ${props => props.theme.colors.white.gray};
    text-transform: uppercase;
    font-size: .8em;
    margin: 0;
  }
`;

const SimilarPost = ({ post }) => (
  <Wrapper>
    <img src={post.legacyPost ? post.image : post.coverImage.url} alt={post.title} />
    <div>
      {post.category && <span className='category'>{post.legacyPost ? post.category[0] : post.category.name}</span>}
      <SecondaryLink key={post.title} href={`https://stackery.io/blog/${post.slug}`} text={post.title} target='_self' />
      {post.subtitle && <p>{post.subtitle}</p>}
    </div>
  </Wrapper>
);

export default SimilarPost;

SimilarPost.propTypes = {
  post: PropTypes.object.isRequired
};
